import { useState } from 'react';
import { initializeDatabase } from '../lib/firebase';
import { seedDatabase } from '../lib/seedData';

export default function TestPage() {
  const [status, setStatus] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [logs, setLogs] = useState<string[]>([]);

  const addLog = (message: string) => {
    setLogs(prev => [...prev, `[${new Date().toISOString()}] ${message}`]);
    console.log(message); // Also log to console for debugging
  };

  const handleInitialize = async () => {
    setIsLoading(true);
    setStatus('Starting initialization...');
    setError('');
    setLogs([]);

    try {
      addLog('Starting database initialization...');
      await initializeDatabase();
      addLog('Database structure initialized.');

      addLog('Starting data seeding...');
      const result = await seedDatabase();
      
      if (result) {
        addLog('Database seeded successfully!');
        setStatus('Database initialized and seeded successfully!');
      } else {
        addLog('Database already contains data.');
        setStatus('Database already contains data. No new data was added.');
      }
      
    } catch (error: any) {
      const errorMessage = error.message || 'An unknown error occurred';
      addLog(`Error: ${errorMessage}`);
      setError(errorMessage);
      setStatus('Initialization failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white shadow rounded-lg p-6">
          <h1 className="text-2xl font-bold mb-4">Database Initialization</h1>
          
          <div className="space-y-4">
            <button
              onClick={handleInitialize}
              disabled={isLoading}
              className={`px-4 py-2 rounded text-white ${
                isLoading 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-green-600 hover:bg-green-700'
              }`}
            >
              {isLoading ? 'Initializing...' : 'Initialize Database'}
            </button>

            {status && (
              <div className="mt-4">
                <div className="font-semibold">Status:</div>
                <pre className="mt-2 p-4 bg-gray-100 rounded whitespace-pre-wrap">
                  {status}
                </pre>
              </div>
            )}
            
            {error && (
              <div className="mt-4">
                <div className="font-semibold text-red-600">Error:</div>
                <pre className="mt-2 p-4 bg-red-50 text-red-600 rounded whitespace-pre-wrap">
                  {error}
                </pre>
              </div>
            )}

            {logs.length > 0 && (
              <div className="mt-4">
                <div className="font-semibold">Detailed Logs:</div>
                <pre className="mt-2 p-4 bg-gray-800 text-green-400 rounded whitespace-pre-wrap text-sm font-mono">
                  {logs.join('\n')}
                </pre>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}